export const CRelatedArticlesFragmets = {
  field: `
    fragment relatedArticles on relatedArticles_MatrixField {
      ... on relatedArticles_block_Entry {
        id
        typeHandle
        idName
        heading
        articles {
          id
          uri
          title
          typeHandle
          ... on testimonialPages_Entry {
            testimonialOccupation
            image: testimonialImage {
          url @transform(mode: "crop", width: 800, immediately: true)
          title
            }
          }
        }
      }
    }
  `,
};
